// extracted by mini-css-extract-plugin
module.exports = {"sentence":"timeline_sentence__qVMFL","text":"timeline_text__Y0eUs","arrow":"timeline_arrow__Z1FA2","extraSentence":"timeline_extraSentence__LjTbO"};